import { create } from 'zustand'
import { persist } from 'zustand/middleware'

/** ルート一覧の地図で線を隠しているプラン。一覧を開き直しても見え方を保つ */
type HiddenRoutePlansState = {
  hiddenIds: number[]
  toggle: (planId: number) => void
  setHidden: (planIds: number[], hidden: boolean) => void
}

export const useHiddenRoutePlansStore = create<HiddenRoutePlansState>()(
  persist(
    (set) => ({
      hiddenIds: [],
      toggle: (planId) =>
        set((state) => ({
          hiddenIds: state.hiddenIds.includes(planId)
            ? state.hiddenIds.filter((id) => id !== planId)
            : [...state.hiddenIds, planId],
        })),
      setHidden: (planIds, hidden) =>
        set((state) => ({
          hiddenIds: hidden
            ? [...new Set([...state.hiddenIds, ...planIds])]
            : state.hiddenIds.filter((id) => !planIds.includes(id)),
        })),
    }),
    {
      name: 'hidden-route-plans',
    },
  ),
)
